import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-10 md:pt-20 pb-6 md:pb-8 px-4 bg-brand-light" data-id="element-265">
      <div className="max-w-5xl mx-auto text-center" data-id="element-266">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-267">
          <span data-id="element-268">🏆</span> El sistema N°1 para docentes de Física en Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-269">
          ⚡ FÍSICA EN ACCIÓN
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-8" data-id="element-270">
          MEGAPACK FÍSICA EN ACCIÓN
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-271">
          7 Tomos organizados por año. +420 páginas con fichas ilustrativas,
          actividades prácticas, experimentos de bajo costo y evaluaciones
          completas. 3 Bonos estratégicos de implementación. Todo alineado al
          Diseño Curricular NAP 2026.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-12" data-id="element-272">
          {['1°', '2°', '3°', '4°', '5°', '6°', 'FERIA'].map(year => <div key={year} className="px-4 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-blue border-2 border-brand-blue/10" data-id="element-273">
              {year}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-274">
          <div className="text-left bg-white p-8 rounded-2xl shadow-xl" data-id="element-275">
            <h4 className="text-2xl font-black text-brand-dark mb-6 border-b pb-4" data-id="element-276">
              7 TOMOS COMPLETOS
            </h4>
            <ul className="space-y-4" data-id="element-277">
              {['Por año', 'Con actividades secuenciadas', 'Con rúbricas integradas', 'Con bonos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-278">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-279" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-280">
            <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/4g1vtJvQmrf2cDKbJQ4uCq/Diseno_sin_titulo_(3).jpg" alt="MegaPack Física en Acción" className="w-full drop-shadow-2xl rounded-xl" data-id="element-282" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}